function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.923096 0.923096H22.8638L33.6042 11.6634V46.3392H0.923096V0.923096Z",
  fill: "#BDDAE4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.8639 0.923096V11.6634H33.6042L22.8639 0.923096Z",
  fill: "#8AD8F2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7013 31.4514L25.5631 36.3132L20.7013 31.4514ZM15.8396 19.7141C19.6369 19.7141 22.7152 22.7924 22.7152 26.5897C22.7152 28.4882 21.9453 30.2071 20.7013 31.4514C19.457 32.6955 17.7384 33.4649 15.8396 33.4649C12.0427 33.4649 8.96436 30.3866 8.96436 26.5897C8.96436 22.7924 12.0427 19.7141 15.8396 19.7141Z",
  fill: "#8AD8F2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.5258 11.632C34.5254 11.6219 34.5251 11.6115 34.5244 11.6018C34.5215 11.5617 34.5171 11.5224 34.5096 11.4835C34.5016 11.4442 34.4905 11.406 34.4778 11.3681C34.4746 11.3587 34.4714 11.3493 34.4677 11.34C34.4544 11.3043 34.4396 11.2693 34.422 11.2358C34.4209 11.2336 34.4202 11.2318 34.4191 11.2296C34.4003 11.1947 34.3783 11.1611 34.3552 11.1283C34.3495 11.12 34.3433 11.1121 34.3372 11.1038C34.3123 11.0713 34.286 11.04 34.2572 11.0108L23.5168 0.270437C23.4876 0.24123 23.4559 0.214907 23.4238 0.190388C23.4155 0.184258 23.4072 0.178128 23.3989 0.171998C23.3665 0.148921 23.333 0.127286 23.2976 0.108535C23.2955 0.107093 23.2933 0.106372 23.2915 0.10529C23.2579 0.0879822 23.223 0.0728377 23.1876 0.0598568C23.1783 0.0562509 23.1685 0.052645 23.1592 0.0493998C23.1213 0.0367795 23.0834 0.0256014 23.0441 0.0180291C23.0438 0.0176685 23.043 0.0176685 23.0427 0.0176685C23.0045 0.0100963 22.9652 0.00576932 22.9262 0.00324524C22.9158 0.00252408 22.9053 0.00180291 22.8948 0.00144233C22.8844 0.00108175 22.8743 0 22.8638 0H0.923092C0.413228 0 0 0.413228 0 0.923092V36.1848C0 36.6947 0.413228 37.1079 0.923092 37.1079C1.43296 37.1079 1.84618 36.6947 1.84618 36.1848V1.84618H21.9407V11.6634C21.9407 12.1733 22.354 12.5865 22.8638 12.5865H32.6811V14.4327C32.6811 14.9426 33.0946 15.3558 33.6042 15.3558C34.114 15.3558 34.5272 14.9426 34.5272 14.4327V11.6634C34.5272 11.653 34.5262 11.6425 34.5258 11.632ZM23.7869 3.15185L31.3757 10.7403H23.7869V3.15185Z",
  fill: "#70BAD3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.6042 20.8943C33.0946 20.8943 32.6811 21.3075 32.6811 21.8174V45.4161H1.84618V43.5695C1.84618 43.06 1.43296 42.6464 0.923092 42.6464C0.413228 42.6464 0 43.06 0 43.5695V46.3392C0 46.849 0.413228 47.2623 0.923092 47.2623H33.6042C34.114 47.2623 34.5272 46.849 34.5272 46.3392V21.8174C34.5272 21.3075 34.114 20.8943 33.6042 20.8943Z",
  fill: "#70BAD3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8398 18.791C11.5399 18.791 8.0415 22.2894 8.0415 26.5897C8.0415 30.8896 11.5399 34.388 15.8398 34.388C17.6121 34.388 19.2942 33.801 20.6637 32.7185L24.9106 36.9655C25.0909 37.1458 25.3271 37.2359 25.5633 37.2359C25.7995 37.2359 26.0357 37.1458 26.216 36.9655C26.5765 36.6052 26.5765 36.0207 26.216 35.6602L21.969 31.4132C23.0515 30.0437 23.6385 28.3616 23.6385 26.5897C23.6385 22.2898 20.1401 18.791 15.8398 18.791ZM20.0489 30.7988C18.9246 31.9227 17.43 32.5418 15.8398 32.5418C12.5578 32.5418 9.88769 29.8717 9.88769 26.5897C9.88769 23.3077 12.5578 20.6376 15.8398 20.6376C19.1219 20.6376 21.792 23.3077 21.792 26.5897C21.7923 28.1795 21.1732 29.6745 20.0489 30.7988Z",
  fill: "#70BAD3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.923092 40.8003C1.43151 40.8003 1.84618 40.386 1.84618 39.8772C1.84618 39.3688 1.43151 38.9541 0.923092 38.9541C0.41467 38.9541 0 39.3688 0 39.8772C0 40.386 0.41467 40.8003 0.923092 40.8003Z",
  fill: "#70BAD3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.6039 17.2019C33.0955 17.2019 32.6808 17.6166 32.6808 18.125C32.6808 18.6334 33.0955 19.0481 33.6039 19.0481C34.1123 19.0481 34.527 18.6334 34.527 18.125C34.527 17.6166 34.1123 17.2019 33.6039 17.2019Z",
  fill: "#70BAD3"
});

function SvgViewFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFile);
export default __webpack_public_path__ + "static/media/viewFile.9fffd7916cf350e2dd0242ad9e72e122.svg";
export { ForwardRef as ReactComponent };